import styled, {keyframes} from 'styled-components'
import {white, landGreen, lightGray} from '@modifi/colors'

const fadeInFromLeft = keyframes`
  0% {
    transform: translateX(-100px);
    opacity: 0;
  }
  100% {
    transform: translateX(0px);
    opacity: 1;
  }
`

// stays above the sticky form footer (80px) so its discard button remains reachable
export const BannerWrapper = styled.div`
  position: fixed;
  bottom: 104px;
  left: 24px;
  z-index: 1000;
  max-width: 320px;
  background-color: ${white};
  border: 1px solid ${lightGray};
  border-left: 4px solid ${landGreen};
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  animation: ${fadeInFromLeft} 1s;
`
